import(/* webpackMode: "eager", webpackExports: ["NavigationHeader"] */ "/home/runner/work/Okkanti/Okkanti/src/app/components/layouts/NavigationHeader.tsx");
